// extracted by mini-css-extract-plugin
export default {"control":"Pagination_control__kV1YX"};